import GoAiguaButton from "./goaiguabutton";

type Props = {
    children: React.ReactNode;
    firstButtonTitle: string;
    secondButtonTitle: string;
    firstButtonStatus: "enabled" | "disabled";
    secondButtonStatus: "enabled" | "disabled";
    onFirstButtonClick: () => void;
    onSecondButtonClick: () => void;
};

const ModalContentLayout: React.FC<Props> = ({
    children,
    firstButtonTitle,
    secondButtonTitle,
    firstButtonStatus,
    secondButtonStatus,
    onFirstButtonClick,
    onSecondButtonClick,
}) => {
    return (
        <section className="l-hierarchy-tree-modal-content-layout">
            <div className="l-hierarchy-tree-modal-content-layout__inner-container">
                {children}
            </div>
            <div className="l-hierarchy-tree-modal-content-layout__buttons-container">
                <GoAiguaButton
                    className={`l-hierarchy-tree-modal-content-layout__button`}
                    onClick={onFirstButtonClick}
                    text={firstButtonTitle}
                    status={firstButtonStatus}
                />

                <GoAiguaButton
                    className={`l-hierarchy-tree-modal-content-layout__button`}
                    onClick={onSecondButtonClick}
                    text={secondButtonTitle}
                    status={secondButtonStatus}
                />
            </div>
        </section>
    );
};

export default ModalContentLayout;
